import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_COMMITTEEMEETINGATTENDANCE_LOAD,
    ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_BY_ID,
    ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_BY_COMMITTEEMEETING_ID,

    ACTION_COMMITTEEMEETINGATTENDANCE_SAVE,

    ACTION_COMMITTEEMEETINGATTENDANCE_CREATE,

    ACTION_COMMITTEEMEETINGATTENDANCE_VALIDATE,

    ICommitteeMeetingAttendanceLoadAction,
    ICommitteeMeetingAttendanceLoadByIdAction,
    ICommitteeMeetingAttendanceLoadByCommitteeMeetingIdAction,
    ICommitteeMeetingAttendanceLoadFailureAction,
    ICommitteeMeetingAttendanceLoadSuccessAction,

    ICommitteeMeetingAttendanceSaveAction,
    ICommitteeMeetingAttendanceSaveSuccessAction,
    ICommitteeMeetingAttendanceSaveFailureAction,

    ICommitteeMeetingAttendanceCreateAction,
    ICommitteeMeetingAttendanceCreateSuccessAction,
    ICommitteeMeetingAttendanceCreateFailureAction,

    ICommitteeMeetingAttendanceValidateAction,
    ICommitteeMeetingAttendanceValidateSuccessAction,
    ICommitteeMeetingAttendanceValidateFailureAction,

    LoadSuccess,
    LoadFailure,


    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/committeeMeetingAttendance";
import { committeeMeetingAttendancesApi } from "../services/committeeMeetingAttendances";


export const
    getCommitteeMeetingAttendancesEpic = (action$): Observable<ICommitteeMeetingAttendanceLoadSuccessAction | ICommitteeMeetingAttendanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEETINGATTENDANCE_LOAD)
            .mergeMap((action: ICommitteeMeetingAttendanceLoadAction) => {
                return committeeMeetingAttendancesApi
                    .getCommitteeMeetingAttendances(action.committeeId)
                    .map(response =>
                        LoadSuccess(response.committeeMeetingAttendances, undefined, [], response.lookups, undefined)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getCommitteeMeetingAttendancesByIdEpic = (action$): Observable<ICommitteeMeetingAttendanceLoadSuccessAction | ICommitteeMeetingAttendanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_BY_ID)
            .mergeMap((action: ICommitteeMeetingAttendanceLoadByIdAction) => {
                return committeeMeetingAttendancesApi
                    .getCommitteeMeetingAttendanceById(action.id)
                    .map(response =>
                        LoadSuccess(response.committeeMeetingAttendance, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getCommitteeMeetingAttendancesByCommitteeMeetingIdEpic = (action$): Observable<ICommitteeMeetingAttendanceLoadSuccessAction | ICommitteeMeetingAttendanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEETINGATTENDANCE_LOAD_BY_COMMITTEEMEETING_ID)
            .mergeMap((action: ICommitteeMeetingAttendanceLoadByCommitteeMeetingIdAction) => {
                return committeeMeetingAttendancesApi
                    .getCommitteeMeetingAttendanceByCommitteeMeetingId(action.committeeMeetingId)
                    .map(response =>
                        LoadSuccess(response.committeeMeetingAttendance, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setCommitteeMeetingAttendanceEpic = (action$): Observable<ICommitteeMeetingAttendanceSaveSuccessAction | ICommitteeMeetingAttendanceSaveFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEETINGATTENDANCE_SAVE)
            .mergeMap((action: ICommitteeMeetingAttendanceSaveAction) => {
                return committeeMeetingAttendancesApi
                    .setCommitteeMeetingAttendance(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.committeeMeetingAttendance, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createCommitteeMeetingAttendanceEpic = (action$): Observable<ICommitteeMeetingAttendanceCreateSuccessAction | ICommitteeMeetingAttendanceCreateFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEETINGATTENDANCE_CREATE)
            .mergeMap((action: ICommitteeMeetingAttendanceCreateAction) => {
                return committeeMeetingAttendancesApi
                    .createCommitteeMeetingAttendance(action.committeeId)
                    .map(response =>
                        CreateSuccess(response.committeeMeetingAttendance, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateCommitteeMeetingAttendanceEpic = (action$): Observable<ICommitteeMeetingAttendanceValidateSuccessAction | ICommitteeMeetingAttendanceValidateFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEETINGATTENDANCE_VALIDATE)
            .mergeMap((action: ICommitteeMeetingAttendanceValidateAction) => {
                return committeeMeetingAttendancesApi
                    .validateCommitteeMeetingAttendance(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.committeeMeetingAttendance, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }